<template>
 <v-app>
   <h3>Курсы для переноса</h3>
   <v-alert
       dense
       text
       type="success"
       v-if="success.length">
     {{ success }}
   </v-alert>
   <div v-for="app in applications" class="spacing-playground pa-6">
     <v-card
         elevation="2"
         outlined
         shaped
     >
       <v-card-title>Заявление от {{ app.person }}</v-card-title>
       <v-card-text>
         <v-row v-for="course in app.courseslist"
             :key="course.id"
             align="center"
             class="mx-0">
           <v-col><h4>Название курса {{course.course_name}}</h4></v-col>
           <v-col><h4>Ссылка на курс <a target="_blank" :href="course.course_url">{{course.course_url}}</a></h4></v-col>
           <v-col><h4>{{app.cathedral}}</h4></v-col>
           <v-btn
               color="blue darken-1"
               text
               @click="createCourse(course.course_name, app.cathedral, app.person_id, applications.indexOf(app), app.courseslist.indexOf(course))"
           >
             Создать курс
           </v-btn>
         </v-row>
         <v-container fluid>
           <v-textarea
               counter
               label="Коментарий"
               v-model="app.comment"
           ></v-textarea>
         </v-container>
       </v-card-text>
       <v-card-actions>
         <v-btn
             color="red darken-1"
             text
             @click="saveApplication(false, app)"
         >
           Отклонить
         </v-btn>
         <v-btn
             color="green darken-1"
             text
             @click="saveApplication(true, app)"
         >
           Готово
         </v-btn>
       </v-card-actions>
     </v-card>
     <div></div>
   </div>
 </v-app>
</template>

<script>

import axios from "axios";

export default {
  name: "estudy_agreed",
  data: () => ({
    applications: [],
    success: "",
  }),
  computed: {},
  methods: {
    getApplications() {
      axios({
        method: 'get',
        url: `/study/applications`,
      }).then((response) => {
        this.applications = response.data.applications;
      }).catch((error) => {
        return error;
      });
    },
    createCourse(course_name, cathedral, person_id, index_a, index_c) {
      axios({
        method: 'get',
        url: `/study/create_course?course_name=${course_name}&person_id=${person_id}&cathedral=${cathedral}`,
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.applications[index_a].courseslist.splice(index_c, 1)
          this.success += `Курс ${course_name} успешно создан ссылка на курс https://newmoodle.amursu.ru/course/view.php?id=${response.data.id}\n\n`
        }
      }).catch((error) => {
        return error;
      });
    },
    saveApplication(stat, app){
      this.dialog = false
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/study/update_application/' + app.id,
        data: {
          course_application: {
            comment: app.comment,
            agreed: stat,
            approved: stat
          },
        }
      }).then((response) => {
        if (response.status === 200 || response.status === 204) {
          this.getApplications()
        }
      }).catch((error) => {
        return error;
      });
    },
  },
  mounted() {
    this.getApplications()
  }
}

</script>

<style scoped>

</style>